export default __webpack_public_path__ + "static/media/fr.81d43a15.svg";